module.exports = __webpack_public_path__ + "img/in.8c1fb065.svg";